import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Post from '@/views/Post.vue';
import Sitemap from '@/views/Sitemap.vue'; // 导入站点地图组件
import SitemapDetail from '@/views/SitemapDetail.vue'; // 导入站点地图详情组件

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/post/:id', name: 'Post', component: Post },
  { path: '/sitemap', name: 'Sitemap', component: Sitemap, meta: { type: 'xml' } }, // 添加 meta 属性
  { path: '/sitemap-:url', name: 'SitemapDetail', component: SitemapDetail, meta: { type: 'xml' } }, // 添加 meta 属性
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;